angular.module('Const').constant('QuoteCalculationType', {
    types: ['default', 'add_surcharge_after_fuel_levy_calculation']
})


// WEBPACK FOOTER //
// ./js/consts/quoteCalculationTypeConst.js